module.exports = __webpack_public_path__ + "img/logo-continium-positief@2x.e42a5868.png";